import { Prisma } from "@prisma/client";

export const pricingDODetailsSelect = {
  id: true,
  pricingDetailsId: true,
  doPrimeHT: true,
  doPrimeTaxes: true,
  doPrimeTTC: true,
  existingDamagesPrimeHT: true,
  existingDamagesPrimeTaxes: true,
  existingDamagesPrimeTTC: true,
  cnrPrimeHT: true,
  cnrPrimeTaxes: true,
  cnrPrimeTTC: true,
  terrorismContributionPrimeHT: true,
  terrorismContributionPrimeTaxes: true,
  terrorismContributionPrimeTTC: true,
  createdAt: true,
  updatedAt: true,
} satisfies Prisma.PricingDODetailsSelect;

export const pricingTRCDetailsSelect = {
  id: true,
  pricingDetailsId: true,
  damageCoveragePrimeHT: true,
  damageCoveragePrimeTaxes: true,
  damageCoveragePrimeTTC: true,
  damageCoverageFirePrimeHT: true,
  damageCoverageFirePrimeTaxes: true,
  damageCoverageFirePrimeTTC: true,
  damageCoverageOtherDamagesPrimeHT: true,
  damageCoverageOtherDamagesPrimeTaxes: true,
  damageCoverageOtherDamagesPrimeTTC: true,
  damageCoverageNaturalDisastersPrimeHT: true,
  damageCoverageNaturalDisastersPrimeTaxes: true,
  damageCoverageNaturalDisastersPrimeTTC: true,
  rcmoPrimeHT: true,
  rcmoPrimeTaxes: true,
  rcmoPrimeTTC: true,
  terrorismContributionPrimeHT: true,
  terrorismContributionPrimeTaxes: true,
  terrorismContributionPrimeTTC: true,
  createdAt: true,
  updatedAt: true,
} satisfies Prisma.PricingTRCDetailsSelect;

export const pricingMRTDetailsSelect = {
  id: true,
  pricingDetailsId: true,
  trcPrimeHT: true,
  trcPrimeTaxes: true,
  trcPrimeTTC: true,
  trcPrimeRateHT: true,
  trcNaturalDisastersPrimeHT: true,
  trcNaturalDisastersPrimeTaxes: true,
  trcNaturalDisastersPrimeTTC: true,
  trcTerrorismContributionPrimeHT: true,
  trcTerrorismContributionPrimeTaxes: true,
  trcTerrorismContributionPrimeTTC: true,
  rcmoPrimeHT: true,
  rcmoPrimeTaxes: true,
  rcmoPrimeTTC: true,
  rcmoPrimeRateHT: true,
  doCnrPrimeHT: true,
  doCnrPrimeTaxes: true,
  doCnrPrimeTTC: true,
  totalClientPrimeRateHT: true,
  createdAt: true,
  updatedAt: true,
} satisfies Prisma.PricingMRTDetailsSelect;

export const pricingDetailsSelect = {
  id: true,
  type: true,
  duneManagementFeesHT: true,
  duneManagementFeesTaxes: true,
  duneManagementFeesTTC: true,
  intermediaryManagementFeesHT: true,
  intermediaryManagementFeesTaxes: true,
  intermediaryManagementFeesTTC: true,
  totalClientPrimeHT: true,
  totalClientPrimeTaxes: true,
  totalClientPrimeTTC: true,
  agreedRateHT: true,
  agreedRateTTC: true,
  brokerCommission: true,
  brokerRemuneration: true,
  totalClientPrimeWithoutBrokerRemuneration: true,
  duneNetCommission: true,
  duneNetRemuneration: true,
  receiptId: true,
  doDetails: {
    select: pricingDODetailsSelect,
  },
  mrtDetails: {
    select: pricingMRTDetailsSelect,
  },
  trcDetails: {
    select: pricingTRCDetailsSelect,
  },
  createdAt: true,
  updatedAt: true,
} satisfies Prisma.PricingDetailsSelect;

export const pricingDetailsDataToCloneSelect = {
  type: true,
  duneManagementFeesHT: true,
  duneManagementFeesTaxes: true,
  duneManagementFeesTTC: true,
  intermediaryManagementFeesHT: true,
  intermediaryManagementFeesTaxes: true,
  intermediaryManagementFeesTTC: true,
  totalClientPrimeHT: true,
  totalClientPrimeTaxes: true,
  totalClientPrimeTTC: true,
  agreedRateHT: true,
  agreedRateTTC: true,
  brokerCommission: true,
  brokerRemuneration: true,
  totalClientPrimeWithoutBrokerRemuneration: true,
  duneNetCommission: true,
  duneNetRemuneration: true,
  doDetails: {
    select: {
      doPrimeHT: true,
      doPrimeTaxes: true,
      doPrimeTTC: true,
      existingDamagesPrimeHT: true,
      existingDamagesPrimeTaxes: true,
      existingDamagesPrimeTTC: true,
      cnrPrimeHT: true,
      cnrPrimeTaxes: true,
      cnrPrimeTTC: true,
      terrorismContributionPrimeHT: true,
      terrorismContributionPrimeTaxes: true,
      terrorismContributionPrimeTTC: true,
      primeHT: true,
      primeTaxes: true,
      primeTTC: true,
    },
  },
  mrtDetails: {
    select: {
      trcPrimeHT: true,
      trcPrimeTaxes: true,
      trcPrimeTTC: true,
      trcPrimeRateHT: true,
      trcNaturalDisastersPrimeHT: true,
      trcNaturalDisastersPrimeTaxes: true,
      trcNaturalDisastersPrimeTTC: true,
      trcTerrorismContributionPrimeHT: true,
      trcTerrorismContributionPrimeTaxes: true,
      trcTerrorismContributionPrimeTTC: true,
      rcmoPrimeHT: true,
      rcmoPrimeTaxes: true,
      rcmoPrimeTTC: true,
      rcmoPrimeRateHT: true,
      doCnrPrimeHT: true,
      doCnrPrimeTaxes: true,
      doCnrPrimeTTC: true,
      totalClientPrimeRateHT: true,
      doCnrPrimeRateHT: true,
    },
  },
  trcDetails: {
    select: {
      damageCoveragePrimeHT: true,
      damageCoveragePrimeTaxes: true,
      damageCoveragePrimeTTC: true,
      damageCoverageFirePrimeHT: true,
      damageCoverageFirePrimeTaxes: true,
      damageCoverageFirePrimeTTC: true,
      damageCoverageOtherDamagesPrimeHT: true,
      damageCoverageOtherDamagesPrimeTaxes: true,
      damageCoverageOtherDamagesPrimeTTC: true,
      damageCoverageNaturalDisastersPrimeHT: true,
      damageCoverageNaturalDisastersPrimeTaxes: true,
      damageCoverageNaturalDisastersPrimeTTC: true,
      rcmoPrimeHT: true,
      rcmoPrimeTaxes: true,
      rcmoPrimeTTC: true,
      terrorismContributionPrimeHT: true,
      terrorismContributionPrimeTaxes: true,
      terrorismContributionPrimeTTC: true
    },
  },
} satisfies Prisma.PricingDetailsSelect;

export type PricingDetailsWithSelect = Prisma.PricingDetailsGetPayload<{
  select: typeof pricingDetailsSelect;
}>;

export const doPricingFieldKeys = [
  "doPrimeHT",
  "doPrimeTaxes",
  "doPrimeTTC",
  "existingDamagesPrimeHT",
  "existingDamagesPrimeTaxes",
  "existingDamagesPrimeTTC",
  "cnrPrimeHT",
  "cnrPrimeTaxes",
  "cnrPrimeTTC",
  "terrorismContributionPrimeHT",
  "terrorismContributionPrimeTaxes",
  "terrorismContributionPrimeTTC",
] as const;

export const mrtPricingFieldKeys = [
  "trcPrimeHT",
  "trcPrimeTaxes",
  "trcPrimeTTC",
  "trcNaturalDisastersPrimeHT",
  "trcNaturalDisastersPrimeTaxes",
  "trcNaturalDisastersPrimeTTC",
  "trcTerrorismContributionPrimeHT",
  "trcTerrorismContributionPrimeTaxes",
  "trcTerrorismContributionPrimeTTC",
  "rcmoPrimeHT",
  "rcmoPrimeTaxes",
  "rcmoPrimeTTC",
  "doCnrPrimeHT",
  "doCnrPrimeTaxes",
  "doCnrPrimeTTC",
] as const;

export const trcPricingFieldKeys = [
  "damageCoveragePrimeHT",
  "damageCoveragePrimeTaxes",
  "damageCoveragePrimeTTC",
  "damageCoverageFirePrimeHT",
  "damageCoverageFirePrimeTaxes",
  "damageCoverageFirePrimeTTC",
  "damageCoverageOtherDamagesPrimeHT",
  "damageCoverageOtherDamagesPrimeTaxes",
  "damageCoverageOtherDamagesPrimeTTC",
  "damageCoverageNaturalDisastersPrimeHT",
  "damageCoverageNaturalDisastersPrimeTaxes",
  "damageCoverageNaturalDisastersPrimeTTC",
  "rcmoPrimeHT",
  "rcmoPrimeTaxes",
  "rcmoPrimeTTC",
  "terrorismContributionPrimeHT",
  "terrorismContributionPrimeTaxes",
  "terrorismContributionPrimeTTC",
] as const;

export const pricingCommonFeeKeys = [
  "duneManagementFeesHT",
  "duneManagementFeesTaxes",
  "duneManagementFeesTTC",
  "intermediaryManagementFeesHT",
  "intermediaryManagementFeesTaxes",
  "intermediaryManagementFeesTTC",
  "brokerCommission",
  "brokerRemuneration",
  "totalClientPrimeHT",
  "totalClientPrimeTaxes",
  "totalClientPrimeTTC",
] as const;

export const pricingRateKeys = [
  "agreedRateHT",
  "agreedRateTTC",
] as const;

export const pricingDODetailsDocumentSelect = {
	doPrimeHT: true,
	doPrimeTaxes: true,
	doPrimeTTC: true,
	primeHT: true,
	primeTaxes: true,
	primeTTC: true,
	existingDamagesPrimeHT: true,
	existingDamagesPrimeTaxes: true,
	existingDamagesPrimeTTC: true,
	cnrPrimeHT: true,
	cnrPrimeTaxes: true,
	cnrPrimeTTC: true,
	terrorismContributionPrimeHT: true,
	terrorismContributionPrimeTaxes: true,
	terrorismContributionPrimeTTC: true,
} as const;

export const pricingTRCDetailsDocumentSelect = {
	damageCoveragePrimeHT: true,
	damageCoveragePrimeTaxes: true,
	damageCoveragePrimeTTC: true,
	damageCoverageFirePrimeHT: true,
	damageCoverageFirePrimeTaxes: true,
	damageCoverageFirePrimeTTC: true,
	damageCoverageOtherDamagesPrimeHT: true,
	damageCoverageOtherDamagesPrimeTaxes: true,
	damageCoverageOtherDamagesPrimeTTC: true,
	damageCoverageNaturalDisastersPrimeHT: true,
	damageCoverageNaturalDisastersPrimeTaxes: true,
	damageCoverageNaturalDisastersPrimeTTC: true,
	rcmoPrimeHT: true,
	rcmoPrimeTaxes: true,
	rcmoPrimeTTC: true,
	terrorismContributionPrimeHT: true,
	terrorismContributionPrimeTaxes: true,
	terrorismContributionPrimeTTC: true,
} as const;

export const pricingMRTDetailsDocumentSelect = {
	trcPrimeHT: true,
	trcPrimeTaxes: true,
	trcPrimeTTC: true,
	trcPrimeRateHT: true,
	trcNaturalDisastersPrimeHT: true,
	trcNaturalDisastersPrimeTaxes: true,
	trcNaturalDisastersPrimeTTC: true,
	trcTerrorismContributionPrimeHT: true,
	trcTerrorismContributionPrimeTaxes: true,
	trcTerrorismContributionPrimeTTC: true,
	rcmoPrimeHT: true,
	rcmoPrimeTaxes: true,
	rcmoPrimeTTC: true,
	rcmoPrimeRateHT: true,
	doCnrPrimeHT: true,
	doCnrPrimeTaxes: true,
	doCnrPrimeTTC: true,
	doCnrPrimeRateHT: true,
	totalClientPrimeRateHT: true,
} as const;

export const pricingDetailsDocumentSelect = {
	duneManagementFeesTTC: true,
	duneManagementFeesTaxes: true,
	duneManagementFeesHT: true,
	intermediaryManagementFeesTTC: true,
	intermediaryManagementFeesTaxes: true,
	intermediaryManagementFeesHT: true,
	brokerCommission: true,
	brokerRemuneration: true,
	totalClientPrimeTTC: true,
	totalClientPrimeTaxes: true,
	totalClientPrimeHT: true,
	totalClientPrimeWithoutBrokerRemuneration: true,
	duneNetCommission: true,
	duneNetRemuneration: true,
  agreedRateHT: true,
  agreedRateTTC: true,
} as const;

export const latestPricingDetailsQuery = {
	orderBy: { createdAt: "desc" } as const,
	take: 1 as const,
};

export type PricingFieldGroup =
	| "base"
	| "doDetails"
	| "trcDetails"
	| "mrtDetails";

const deepMergeSelects = (
	target: Record<string, boolean | object>,
	source: Record<string, boolean | object>
): Record<string, boolean | object> => {
	for (const [key, value] of Object.entries(source)) {
		if (
			typeof value === "object" &&
			value !== null &&
			!Array.isArray(value) &&
			typeof target[key] === "object" &&
			target[key] !== null &&
			!Array.isArray(target[key])
		) {
			target[key] = deepMergeSelects(
				target[key] as Record<string, boolean | object>,
				value as Record<string, boolean | object>
			);
		} else {
			target[key] = value;
		}
	}
	return target;
};
export const buildPricingDetailsSelect = (
	groups: PricingFieldGroup[],
): Record<string, boolean | object> => {
	const uniqueGroups = Array.from(new Set(groups));
	const select: Record<string, boolean | object> = {};

	uniqueGroups.forEach((group) => {
		switch (group) {
			case "base":
				deepMergeSelects(
					select,
					pricingDetailsDocumentSelect as Record<string, boolean | object>,
				);
				break;
			case "doDetails":
				select.doDetails = { select: pricingDODetailsDocumentSelect };
				break;
			case "trcDetails":
				select.trcDetails = { select: pricingTRCDetailsDocumentSelect };
				break;
			case "mrtDetails":
				select.mrtDetails = { select: pricingMRTDetailsDocumentSelect };
				break;
			default:
				break;
		}
	});

	return select;
};

export const buildPricingDetailsRelationSelect = (groups: PricingFieldGroup[]) => ({
	...latestPricingDetailsQuery,
	select: buildPricingDetailsSelect(groups),
});

export const pricingFieldLabelMap: Record<string, string> = {
  doPrimeHT: "DO HT",
  doPrimeTaxes: "DO Taxes",
  doPrimeTTC: "DO TTC",
  existingDamagesPrimeHT: "Dommages Existants HT",
  existingDamagesPrimeTaxes: "Dommages Existants Taxes",
  existingDamagesPrimeTTC: "Dommages Existants TTC",
  cnrPrimeHT: "CNR HT",
  cnrPrimeTaxes: "CNR Taxes",
  cnrPrimeTTC: "CNR TTC",
  terrorismContributionPrimeHT: "Attentats HT",
  terrorismContributionPrimeTaxes: "Attentats Taxes",
  terrorismContributionPrimeTTC: "Attentats TTC",
  trcPrimeHT: "TRC HT",
  trcPrimeTaxes: "TRC Taxes",
  trcPrimeTTC: "TRC TTC",
  trcNaturalDisastersPrimeHT: "Cat. Nat. HT",
  trcNaturalDisastersPrimeTaxes: "Cat. Nat. Taxes",
  trcNaturalDisastersPrimeTTC: "Cat. Nat. TTC",
  trcTerrorismContributionPrimeHT: "Attentats HT",
  trcTerrorismContributionPrimeTaxes: "Attentats Taxes",
  trcTerrorismContributionPrimeTTC: "Attentats TTC",
  rcmoPrimeHT: "RC MO HT",
  rcmoPrimeTaxes: "RC MO Taxes",
  rcmoPrimeTTC: "RC MO TTC",
  doCnrPrimeHT: "DO+CNR HT",
  doCnrPrimeTaxes: "DO+CNR Taxes",
  doCnrPrimeTTC: "DO+CNR TTC",
  damageCoveragePrimeHT: "Garantie Dommages HT",
  damageCoveragePrimeTaxes: "Garantie Dommages Taxes",
  damageCoveragePrimeTTC: "Garantie Dommages TTC",
  damageCoverageFirePrimeHT: "Dont Incendie HT",
  damageCoverageFirePrimeTaxes: "Dont Incendie Taxes",
  damageCoverageFirePrimeTTC: "Dont Incendie TTC",
  damageCoverageOtherDamagesPrimeHT: "Autres Dommages HT",
  damageCoverageOtherDamagesPrimeTaxes: "Autres Dommages Taxes",
  damageCoverageOtherDamagesPrimeTTC: "Autres Dommages TTC",
  damageCoverageNaturalDisastersPrimeHT: "Cat. Nat. HT",
  damageCoverageNaturalDisastersPrimeTaxes: "Cat. Nat. Taxes",
  damageCoverageNaturalDisastersPrimeTTC: "Cat. Nat. TTC",
};